<template>
  <div no-body class="salary-slip daily-container">
    <!-- 公司信息头部 -->
    <div class="company-header">
      <div class="logo">
        <img src="@/assets/images/logo/salary_logo.png" alt="WF Logo" />
      </div>
      <div class="company-info">
        <h1>{{ companyInfo.company_name || "永發設計工程有限公司-會計部" }}</h1>
        <p v-if="companyInfo.address">地址： {{ companyInfo.address }}</p>
        <p v-if="companyInfo.phone">電話： {{ companyInfo.phone }}</p>
        <p v-if="companyInfo.website">網址： {{ companyInfo.website }}</p>
        <p v-if="companyInfo.email">電郵： {{ companyInfo.email }}</p>
        <!-- 載入中或錯誤時顯示預設資訊 -->
        <template v-if="!companyInfo.address && !isLoadingCompanyInfo">
          <p>地址： 新界元朗鳳翔路 45-67 號金馬大廈 29 樓地下</p>
          <p>電話： 24798967</p>
          <p>網址： http://wingfatdesign.com</p>
          <p>電郵： sales@wingfatdesign.com</p>
        </template>
      </div>
    </div>

    <h2 class="slip-title">工資單</h2>
    <!-- {{ pdfData }} -->
    <!-- 员工基本信息表格 -->
    <div class="employee-info">
      <table class="info-table">
        <tr>
          <td>員工証明：</td>
          <td>{{ pdfData.name_cn }}</td>
          <td>計薪方式：</td>
          <td>日薪</td>
        </tr>
        <tr>
          <td>系統帳號：</td>
          <td>{{ pdfData.name }}</td>
          <td>支付帳號名稱：</td>
          <td>{{ pdfData.bank_account_name }}</td>
        </tr>
        <tr>
          <td>員工編號：</td>
          <td>{{ pdfData.user_number }}</td>
          <td>支付帳號號碼：</td>
          <td>{{ pdfData.bank_account }}</td>
        </tr>
        <tr>
          <td>職位：</td>
          <td>{{ pdfData.position }}</td>
          <td>銀行識別編號：</td>
          <td v-if="pdfData.bank_id">
            {{
              bankOptions &&
              bankOptions.length > 0 &&
              bankOptions.find((bank) => bank.id === pdfData.bank_id).name
            }}
          </td>
        </tr>
        <tr>
          <td>部門：</td>
          <td>{{ pdfData.department }}</td>
          <td>入職日期：</td>
          <td>{{ pdfData.join_date }}</td>
        </tr>
        <tr>
          <td>支付方式：</td>
          <td>
            {{ getSalaryReceiveMethodName() }}
            <span v-if="isChecquePayment() && currentMonth.check_number">
              <br />支票號碼：{{ currentMonth.check_number }}
            </span>
          </td>
          <td>支付日期：</td>
          <td>{{ (currentMonth.payment_date && currentMonth.payment_date.split("T")[0]) || "不適用" }}</td>
        </tr>
        <!-- ... 其他员工信息行 ... -->
      </table>
    </div>
    <!-- currentMonth{{ currentMonth }} -->
<!-- <br/> -->

    <!-- historyRecords{{ historyRecords }} -->
    <!-- 工资明细表格 -->
    <div class="salary-details">
      <div class="d-flex justify-content-between">
        <h3>工資(最近一個月) - {{ currentMonth.year }}/{{ currentMonth.month >= 10 ? currentMonth.month : '0' + currentMonth.month }}</h3>
        <b>HKD</b>
      </div>
      <table class="salary-table">
        <tr>
          <td>發票號碼</td>
          <td class="invoice-info">{{ currentMonth.invoice_numbers || '--' }}</td>
        </tr>
        <tr>
          <td>施工地址</td>
          <td class="address-info">{{ currentMonth.addresses || '--' }}</td>
        </tr>
        <tr>
          <td>固定工資</td>
          <td class="amount">{{ currentMonth.total_salary }}</td>
        </tr>
        <tr>
          <td>逾時工作/遲到/早退</td>
          <td class="amount">
            {{
              currentMonth.ot_amount ? currentMonth.ot_amount : "不適用"
            }}
          </td>
        </tr>
        <tr>
          <td>佣金或花紅</td>
          <td class="amount">
            {{ currentMonth.commission ? currentMonth.commission : "不適用" }}
          </td>
        </tr>
        <tr>
          <td>其他津貼  {{ currentMonth.allowance_remark ? ` - ${currentMonth.allowance_remark}` : "" }}</td>
          <td class="amount">
            {{ currentMonth.allowance ? currentMonth.allowance : "不適用" }}
          </td>
        </tr>
        <tr v-if="pdfData.mpf_employer">
          <td>強積金強制供款（僱主部份）</td>
          <td class="amount">
            {{
              currentMonth.mpf_employer ? currentMonth.mpf_employer : "不適用"
            }}
          </td>
        </tr>
        <tr v-if="pdfData.mpf_employee">
          <td>強積金強制供款（僱員部份）</td>
          <td class="amount">
            {{
              currentMonth.mpf_employee ? currentMonth.mpf_employee : "不適用"
            }}
          </td>
        </tr>
        <tr>
          <td>預支總金額</td>
          <td class="amount">
            {{
              currentMonth.prepayment_amount ? currentMonth.prepayment_amount : "不適用"
            }}
          </td>
        </tr>
        <!-- ... 其他工资项目 ... -->
      </table>
      <div class="salary-total">
        <div class="d-flex justify-content-end">
          <b>應發工資：</b>
          <span class="amount">{{
            currentMonth.gross_salary ? currentMonth.gross_salary : `0.00`
          }}</span>
        </div>
        <div class="d-flex justify-content-end">
          <b>實發工資：</b>
          <span class="amount">{{
            currentMonth.actual_salary ? currentMonth.actual_salary : `0.00`
          }}</span>
        </div>
      </div>
    </div>



    <!-- 历史工资记录表格 -->
    <div class="salary-history mt-1">
      <div class="d-flex align-items-end justify-content-between">
        <b class="">過往 11 個月工資</b>
        <div class="signature"></div>
      </div>
      <table class="history-table">
        <thead>
          <tr>
            <th>過往月份</th>
            <th>施工地址</th>
            <th>發票號碼</th>
            <th>逾時工作</th>
            <th style="font-size:13px">佣金/花紅</th>
            <th>其他津貼</th>
            <th>預支金額</th>
            <th>實發工資</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in historyRecords" :key="item.key">
            <td>{{ item.year }}/{{item.month >=10 ? item.month : '0' + item.month }}</td>
            <td class="address-info">{{ item.addresses || '--' }}</td>
            <td class="invoice-info">{{ item.invoice_numbers || '--' }}</td>
            <td>{{ item.ot_amount ? item.ot_amount : '0.00' }}</td>
            <td>{{ item.commission ? item.commission : '0.00' }}</td>
            <td>{{ item.allowance ? item.allowance : '0.00' }}</td>
            <td>{{ item.prepayment_amount ? item.prepayment_amount : '0.00' }}</td>
            <td>{{ item.actual_salary ? item.actual_salary : '0.00' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="footer-note">
      本糧單由系統自動生成，資方可按需要在空白位置蓋章以作証明。
    </div>
  </div>
</template>
<script>
import { BRow, BCol, BCard, BCardBody, BCardText } from "bootstrap-vue";

import { mapFields } from "vuex-map-fields";
import { formatMoney } from "@/libs/helper.js";
import NoticeToCustomers from "@/views/invoice/invoices-preview/NoticeToCustomers.vue";
import { ref, watch } from "@vue/composition-api";
import axiosIns from "@/libs/axios";

export default {
  data() {
    return {
      month: [
        "Jan",
        "Feb",
        "March",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      pages: [],
      companyInfo: {
        company_name: "",
        address: "",
        phone: "",
        website: "",
        email: "",
      },
      isLoadingCompanyInfo: false,
    };
  },

  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardText,
  },
  props: {
    pdfData: {
      type: Object,
      required: true,
    },
    templateOptions: {
      type: Array,
      required: true,
    },
    stampOptions: {
      type: Array,
      required: true,
    },
    projectOptions: {
      type: Array,
      required: true,
    },
    bankOptions: {
      type: Array,
      required: true,
    },
    remarkOptions: {
      type: Array,
      required: true,
    },
  },

  computed: {
    ...mapFields(["controlValue"]),
    currentMonth() {
      const defaultData = {
        month: '',
        year: '',
        total_salary: '0.00',
        gross_salary: '0.00',
        actual_salary: '0.00',
        ot_amount: '0.00',
        commission: '0.00',
        allowance: '0.00',
        allowance_remark: '',
        mpf_employer: '0.00',
        mpf_employee: '0.00',
        prepayment_amount: '0.00',
        payment_date: null,
        payment_method: null,
        check_number: '',
        invoices: [],
      };

      // 安全檢查：確保 pdfData 和 salary_records 存在
      if (!this.pdfData || !this.pdfData.salary_records || !Array.isArray(this.pdfData.salary_records) || this.pdfData.salary_records.length === 0) {
        return defaultData;
      }

      // 日薪邏輯：找到當前月份的記錄並匯總所有 summaries
      const currentRecord = this.pdfData.salary_records.find(record => record && record.is_current === true);

      if (!currentRecord) {
        // 如果沒有標記為當前的記錄，使用第一筆記錄
        const firstRecord = this.pdfData.salary_records[0];
        if (firstRecord && firstRecord.summaries && firstRecord.summaries.length > 0) {
          return this.aggregateSummaries(firstRecord);
        }
        return defaultData;
      }

      if (currentRecord.summaries && currentRecord.summaries.length > 0) {
        return this.aggregateSummaries(currentRecord);
      }

      return defaultData;
    },

    historyRecords() {
      // 安全檢查：確保 pdfData 和 salary_records 存在
      if (!this.pdfData || !this.pdfData.salary_records || !Array.isArray(this.pdfData.salary_records) || this.pdfData.salary_records.length === 0) {
        return [];
      }

      // 日薪邏輯：處理每個月的 summaries，排除當前記錄
      return this.pdfData && this.pdfData.salary_records && this.pdfData.salary_records.length > 0
        && this.pdfData.salary_records.filter(record => record && !record.is_current)
        .map(record => {
          if (record.summaries && record.summaries.length > 0) {
            // 匯總該月所有項目的資料
            const aggregated = this.aggregateSummaries(record);
            return {
              ...aggregated,
              key: `${record.year}-${record.month}`,
            };
          } else {
            // 空記錄
            return {
              key: `${record.year}-${record.month}`,
              year: record.year,
              month: record.month,
              total_salary: '0.00',
              gross_salary: '0.00',
              actual_salary: '0.00',
              ot_amount: '0.00',
              commission: '0.00',
              allowance: '0.00',
              allowance_remark: '',
              mpf_employer: '0.00',
              mpf_employee: '0.00',
              prepayment_amount: '0.00',
              payment_method: null,
              check_number: '',
              invoice_numbers: '--',
              addresses: '--',
              invoices: [],
            };
          }
        });
    },


  },
  methods: {
    formatMoney,
    aggregateSummaries(record) {
      const summaries = record.summaries;

      const aggregatedData = {
        year: record.year,
        month: record.month,
        total_salary: '0.00',
        gross_salary: '0.00',
        actual_salary: '0.00',
        ot_amount: '0.00',
        commission: '0.00',
        allowance: '0.00',
        allowance_remark: '',
        mpf_employer: '0.00',
        mpf_employee: '0.00',
        prepayment_amount: '0.00',
        payment_date: null,
        payment_method: null,
        check_number: '',
        invoices: [],
        invoice_numbers: '',
        addresses: '',
      };

      // 匯總所有項目的金額
      let totalSalary = 0;
      let grossSalary = 0;
      let actualSalary = 0;
      let otAmount = 0;
      let commission = 0;
      let allowance = 0;
      let mpfEmployer = 0;
      let mpfEmployee = 0;
      let prepaymentAmount = 0;
      let allowanceRemarks = [];
      let invoiceNumbers = [];
      let addresses = [];
      let invoices = [];

      summaries.forEach(summary => {
        totalSalary += parseFloat(summary.total_salary || 0);
        grossSalary += parseFloat(summary.gross_salary || 0);
        actualSalary += parseFloat(summary.actual_salary || 0);
        otAmount += parseFloat(summary.ot_amount || 0);
        commission += parseFloat(summary.commission || 0);
        allowance += parseFloat(summary.allowance || 0);
        mpfEmployer += parseFloat(summary.mpf_employer || 0);
        mpfEmployee += parseFloat(summary.mpf_employee || 0);
        prepaymentAmount += parseFloat(summary.prepayment_amount || 0);

        // 收集津貼備註
        if (summary.allowance_remark && summary.allowance_remark.trim()) {
          allowanceRemarks.push(summary.allowance_remark.trim());
        }

        // 收集發票號碼
        if (summary.invoice_number && summary.invoice_number.trim()) {
          invoiceNumbers.push(summary.invoice_number.trim());
        }

        // 收集地址
        if (summary.address && summary.address.trim()) {
          addresses.push(summary.address.trim());
        }

        // 收集完整的發票資訊
        if (summary.invoice_id) {
          invoices.push({
            invoice_id: summary.invoice_id,
            invoice_number: summary.invoice_number || '',
            address: summary.address || '',
          });
        }

        // 使用第一個有效的支付日期、支付方式和支票號碼
        if (!aggregatedData.payment_date && summary.payment_date) {
          aggregatedData.payment_date = summary.payment_date;
        }

        if (!aggregatedData.payment_method && summary.payment_method) {
          aggregatedData.payment_method = summary.payment_method;
        }

        if (!aggregatedData.check_number && summary.check_number) {
          aggregatedData.check_number = summary.check_number;
        }
      });

      // 格式化匯總結果
      aggregatedData.total_salary = totalSalary.toFixed(2);
      aggregatedData.gross_salary = grossSalary.toFixed(2);
      aggregatedData.actual_salary = actualSalary.toFixed(2);
      aggregatedData.ot_amount = otAmount.toFixed(2);
      aggregatedData.commission = commission.toFixed(2);
      aggregatedData.allowance = allowance.toFixed(2);
      aggregatedData.mpf_employer = mpfEmployer.toFixed(2);
      aggregatedData.mpf_employee = mpfEmployee.toFixed(2);
      aggregatedData.prepayment_amount = prepaymentAmount.toFixed(2);
      aggregatedData.allowance_remark = allowanceRemarks.join(', ');
      aggregatedData.invoice_numbers = invoiceNumbers.join(' / ');
      aggregatedData.addresses = addresses.join(' / ');
      aggregatedData.invoices = invoices;

      return aggregatedData;
    },

    async fetchCompanyInfo() {
      this.isLoadingCompanyInfo = true;
      try {
        const response = await axiosIns.get("templates/1");
        const template = response.data.template;
        this.companyInfo = {
          company_name: "永發設計工程有限公司-會計部",
          address: template.address || "",
          phone: template.phone || "",
          website: template.website || "",
          email: template.email || "",
        };
      } catch (error) {
        console.error("獲取公司資訊失敗:", error);
        // 保持預設值，不做任何改變
      } finally {
        this.isLoadingCompanyInfo = false;
      }
    },

    isChecquePayment() {
      return this.currentMonth.payment_method && this.currentMonth.payment_method.is_cheque;
    },

    getSalaryReceiveMethodName() {
      if (this.currentMonth.payment_method && this.currentMonth.payment_method.name) {
        return this.currentMonth.payment_method.name;
      }
      return '未指定';
    },

    //備用
    getNumberFormat(amount) {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "HKD",
        minimumFractionDigits: 2,
      });
      return formatter.format(amount);
    },
  },
  mounted() {
    // 載入公司資訊
    this.fetchCompanyInfo();

    // this.$nextTick(() => {
    //     setTimeout(() => {
    //         this.$emit("domRendered");
    //     }, 1000);
    // });
  },
}
</script>

<style lang="scss">
.salary-slip.daily-container {
  padding: 40px;
  max-width: 100%;
  margin: 0 auto;
  height: 1100px;

  background: #fff;
  * {
    font-family: 新細明體;
  }

  .company-header {
    display: flex;
    // align-items: center;

    .logo {
      width: 120px;
      margin-right: 20px;
      margin-top: -10px;

      img {
        width: 100%;
      }
    }

    .company-info {
      h1 {
        font-size: 18px;
        margin-bottom: 10px;
      }
      p {
        margin: 5px 20px;
        color: #666;
        font-size: 12px;
      }
    }
  }

  .slip-title {
    text-align: right;
    font-size: 24px;
    margin: 0px 0 0;
    border-bottom: 1px solid #000;
  }
  .salary-details {
    h3 {
      font-size: 16px;
    }
    table {
      td {
        padding: 4px;
        border-bottom: 1px solid #000;
      }
    }
  }
  .salary-total {
    .amount {
      width: 100px;
    }
  }
  .info-table,
  .salary-table,
  .history-table {
    width: 100%;
    border-collapse: collapse;
    margin: 0px 0 15px;
    border-bottom: 1px solid #000;

    td,
    th {
      padding: 3px !important;
      // border: 1px solid #ddd;
    }
  }

  .history-table {
    width: 100%;
    max-width: 100%;
    th,
    td {
      // background-color: #f5f5f5;
      font-weight: bold;
      border: 1px solid #000;
      &:first-child, &:nth-child(4), &:nth-child(5), &:nth-child(6), &:nth-child(7),  &:nth-child(8) {
        width: 68px;
        max-width: 68px;
        min-width: 68px;
      }
      &:nth-child(2), &:nth-child(3) {
        width: 154px;
        max-width: 154px;
        min-width: 154px;
      }
    }
  }



  .amount {
    text-align: right;
  }

  .invoice-info {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .address-info {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .salary-details{
     .invoice-info, .address-info  {
        text-align: right;
        max-width: 280px;
     }
  }
  .salary-history{
    .address-info, .invoice-info  {
        text-align: left;
     }
     .address-info{
        max-width: 180px;
     }
  }

  .footer-note {
    margin-top: 30px;
    text-align: center;
    font-size: 14px;
    color: #666;
  }
  .signature {
    width: 200px;
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
    height: 3px;
    margin-bottom: 4px;
    position: relative;
    &:before {
      content: "簽名:";
      font-size: 12px;
      color: #666;
      position: absolute;
      top: -20px;
      left: -30px;
    }
  }
}
</style>
